import React, { useState } from "react";

import "./AmountInput.scss";
import { t } from "i18next";

interface IAmountInput {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
}

const AmountInput = ({ inputValue, setInputValue }: IAmountInput) => {
  const [inputFocused, setInputFocused] = useState(false);
  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (inputValue && inputValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
  };
  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default ${inputFocused ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="text"
            inputMode="decimal"
            className="form-control-input-bc"
            name="name"
            step={0}
            defaultValue=""
            value={inputValue}
            onChange={onChangeInput}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">
            {t("admin.Amount")}
          </span>
        </label>
      </div>
    </div>
  );
};

export { AmountInput };
